import { render, staticRenderFns } from "./CommissionSplitForm.vue?vue&type=template&id=d5e60194"
import script from "./CommissionSplitForm.vue?vue&type=script&lang=js"
export * from "./CommissionSplitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports